import React from 'react';

import { ComponentInfo } from '@components';

import { CorporateForm, CorporateFormSkeleton } from './block';
import { useCorporateDataHelper } from './corporateData.helper';

export const CorporateDataPlaceholder: React.FC = () => {
	const { title, pagePadding, isLoading } = useCorporateDataHelper();

	return (
		<ComponentInfo name="CorporateDataPlaceholder" type="placeholder">
			{isLoading !== undefined && isLoading ? (
				<CorporateFormSkeleton title={title} pagePadding={pagePadding} />
			) : (
				<CorporateForm title={title} pagePadding={pagePadding} />
			)}
		</ComponentInfo>
	);
};
